var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAllInclusive = function SvgIconAllInclusive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon_all-inclusive_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_all-inclusive_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5.92a.5.5 0 0 1 .5.5v8a.5.5 0 1 1-1 0v-8a.5.5 0 0 1 .5-.5Zm-2 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0v-8a.5.5 0 0 1 .5-.5ZM19 2.58A11 11 0 0 0 17 7a29.47 29.47 0 0 0-1 5.88h1.5a.5.5 0 0 1 .5.5v8c0 .39.11.5.5.5s.5-.11.5-.5Zm1-1.16v20a1.38 1.38 0 0 1-1.5 1.5 1.38 1.38 0 0 1-1.5-1.5v-7.5h-1.5a.5.5 0 0 1-.5-.5 28.81 28.81 0 0 1 1-6.62c.71-2.8 1.76-4.7 3.2-5.8a.5.5 0 0 1 .8.42Zm-9-.07c.68 4.71 1 7.37 1 8.07s-.4 1-1.72 1.92C9.35 12 9 12.27 9 12.42v9a1.38 1.38 0 0 1-1.5 1.5 1.38 1.38 0 0 1-1.5-1.5v-9c0-.15-.35-.47-1.28-1.08C3.4 10.45 3 10.1 3 9.42s.33-3.36 1-8.07a.49.49 0 0 1 .57-.42.5.5 0 0 1 .43.56c-.66 4.63-1 7.3-1 7.93 0 .15.35.47 1.28 1.09C6.6 11.39 7 11.74 7 12.42v9c0 .39.11.5.5.5s.5-.11.5-.5v-9c0-.68.4-1 1.72-1.91.93-.62 1.28-.94 1.28-1.09 0-.63-.33-3.3-1-7.93a.5.5 0 0 1 .42-.56.49.49 0 0 1 .58.42Z",
    className: "icon_all-inclusive_svg__cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_all-inclusive_svg__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-5.08h27v34H-2z",
    className: "icon_all-inclusive_svg__cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_all-inclusive_svg__clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 .92h17v22H3z",
    className: "icon_all-inclusive_svg__cls-1"
  })), /*#__PURE__*/React.createElement("style", null, ".icon_all-inclusive_svg__cls-1{fill:#4a4a4a}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5.92a.5.5 0 0 1 .5.5v8a.5.5 0 1 1-1 0v-8a.5.5 0 0 1 .5-.5Zm-2 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0v-8a.5.5 0 0 1 .5-.5ZM19 2.58A11 11 0 0 0 17 7a29.47 29.47 0 0 0-1 5.88h1.5a.5.5 0 0 1 .5.5v8c0 .39.11.5.5.5s.5-.11.5-.5Zm1-1.16v20a1.38 1.38 0 0 1-1.5 1.5 1.38 1.38 0 0 1-1.5-1.5v-7.5h-1.5a.5.5 0 0 1-.5-.5 28.81 28.81 0 0 1 1-6.62c.71-2.8 1.76-4.7 3.2-5.8a.5.5 0 0 1 .8.42Zm-9-.07c.68 4.71 1 7.37 1 8.07s-.4 1-1.72 1.92C9.35 12 9 12.27 9 12.42v9a1.38 1.38 0 0 1-1.5 1.5 1.38 1.38 0 0 1-1.5-1.5v-9c0-.15-.35-.47-1.28-1.08C3.4 10.45 3 10.1 3 9.42s.33-3.36 1-8.07a.49.49 0 0 1 .57-.42.5.5 0 0 1 .43.56c-.66 4.63-1 7.3-1 7.93 0 .15.35.47 1.28 1.09C6.6 11.39 7 11.74 7 12.42v9c0 .39.11.5.5.5s.5-.11.5-.5v-9c0-.68.4-1 1.72-1.91.93-.62 1.28-.94 1.28-1.09 0-.63-.33-3.3-1-7.93a.5.5 0 0 1 .42-.56.49.49 0 0 1 .58.42Z",
    className: "icon_all-inclusive_svg__cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#icon_all-inclusive_svg__clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2-5.08h27v34H-2z",
    className: "icon_all-inclusive_svg__cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#icon_all-inclusive_svg__clip-path-2)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 .92h17v22H3z",
    className: "icon_all-inclusive_svg__cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-2-4.08h27v32H-2z",
    className: "icon_all-inclusive_svg__cls-1",
    style: {
      clipPath: "url(#icon_all-inclusive_svg__clip-path-3)"
    }
  })))));
};
export default SvgIconAllInclusive;